var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.172pt",
    height: "14.172pt",
    viewBox: "0 0 14.172 14.172",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m119.6 23.152v-0.25h-127.31v-175.25h127.06v175.5h0.25v-0.25 0.25h0.25v-176h-128.06v176.25h128.06v-0.25zm-59.531-160.16h-0.25c0 1.1055-0.44531 2.1055-1.1719 2.8281-0.72266 0.72656-1.7227 1.1758-2.8281 1.1758-1.1055 0-2.1055-0.44922-2.832-1.1758-0.72265-0.72266-1.1719-1.7227-1.1719-2.8281s0.44922-2.1055 1.1719-2.8281c0.72657-0.72656 1.7266-1.1719 2.832-1.1719 1.1055 0 2.1055 0.44532 2.8281 1.1719 0.72656 0.72265 1.1719 1.7226 1.1719 2.8281h0.5c0-2.4844-2.0156-4.5-4.5-4.5-2.4883 0-4.5039 2.0156-4.5039 4.5 0 2.4844 2.0156 4.5039 4.5039 4.5039 2.4844 0 4.5-2.0195 4.5-4.5039",
    fill: "#4f5257"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#171817",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.8515 1.5977h-1.5391v4.6875h1.5391zm1.5938-1.5977v14.148h-1.5547v-6.2539h-1.5938v6.2578h-1.5742v-14.152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.1484 2.678e-5v1.5625h-1.5547v4.7227h1.5312v1.5781h-1.5352v4.7305h1.5391v1.5781h-3.1289v-14.172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.172 14.172h-3.1524v-14.172h3.1524v1.5742h-1.5586v11.023h1.5586"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEac);
export default __webpack_public_path__ + "static/media/eac.219240037f5ea0413919e231e33689c6.svg";
export { ForwardRef as ReactComponent };